/** Plain text from an HTML string (Store API descriptions are HTML). */
export function htmlToText(html: string): string {
  if (!html) return '';
  const d = document.createElement('div');
  d.innerHTML = html;
  return (d.textContent || '').replace(/\s+/g, ' ').trim();
}
